export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    align: 'center',
    width: 120,
    slots: {
      default: 'opt',
    },
  },
  {
    title: that.$l('table_title_fileName') || '文档名称',
    field: 'fileName',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_title_fileType') || '文档类型',
    field: 'fileType',
    align: 'center',
    minWidth: 150,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_title_fileUrl') || '文档下载url地址',
    field: 'fileUrl',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_title_uploadTime') || '上传时间',
    field: 'uploadTime',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('table_title_uploadByName') || '上传人姓名',
    field: 'uploadByName',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
